import * as Sentry from "@sentry/browser";

const initalize = () => {
  if (process.env.REACT_APP_SENTRY_URL) {
    Sentry.init({ dsn: process.env.REACT_APP_SENTRY_URL });

    Sentry.withScope((scope) => {
      scope.setTag("application", "my-hoopla");
      scope.setTag("environment", process.env.REACT_APP_ENVIRONMENT);
    });
  }
};

export default initalize;
